import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notification-content" }
const _hoisted_2 = { class: "notification-icon" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "notification-message" }

import { ref, onMounted, onBeforeUnmount } from 'vue'

// Define props interface
interface Props {
  message: string
  type?: 'info' | 'success' | 'warning' | 'error'
  duration?: number
}

interface Emits {
  close: []
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    message: {},
    type: { default: 'info' },
    duration: { default: 5000 }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props

// Define emits interface
const emit = __emit

// Reactive data
const show = ref(true)
const timer = ref<NodeJS.Timeout | null>(null)

// Methods
const closeNotification = (): void => {
  show.value = false
  setTimeout(() => {
    emit('close')
  }, 300) // Wait for animation to complete
}

// Lifecycle hooks
onMounted(() => {
  if (props.duration > 0) {
    timer.value = setTimeout(() => {
      closeNotification()
    }, props.duration)
  }
})

onBeforeUnmount(() => {
  if (timer.value) {
    clearTimeout(timer.value)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "notification-slide" }, {
    default: _withCtx(() => [
      (show.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['notification', `notification-${_ctx.type}`])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.type === 'error')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "⚠️"))
                  : (_ctx.type === 'success')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "✅"))
                    : (_ctx.type === 'warning')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "⚠️"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, "ℹ️"))
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.message), 1)
            ]),
            _createElementVNode("button", {
              class: "notification-close",
              onClick: closeNotification
            }, "×")
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})